var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisconnectModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3513 21.0001L16.018 4.66677C15.8145 4.30767 15.5194 4.00898 15.1628 3.80118C14.8061 3.59337 14.4008 3.48389 13.988 3.48389C13.5753 3.48389 13.1699 3.59337 12.8133 3.80118C12.4566 4.00898 12.1615 4.30767 11.958 4.66677L2.62467 21.0001C2.41897 21.3564 2.31111 21.7607 2.31202 22.172C2.31293 22.5834 2.42258 22.9872 2.62986 23.3426C2.83714 23.6979 3.13468 23.9921 3.49232 24.1954C3.84996 24.3987 4.25498 24.5038 4.66634 24.5001H23.333C23.7424 24.4997 24.1445 24.3916 24.4988 24.1866C24.8532 23.9816 25.1474 23.687 25.3519 23.3324C25.5564 22.9778 25.6641 22.5756 25.6639 22.1662C25.6638 21.7568 25.556 21.3546 25.3513 21.0001Z",
    stroke: "#FB2C36",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.5V15.1667",
    stroke: "#FB2C36",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.8334H14.0117",
    stroke: "#FB2C36",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectModal);
export default __webpack_public_path__ + "static/media/disconnect_modal.34459a132eead0b5b81e3e94429ca4aa.svg";
export { ForwardRef as ReactComponent };